;(function (window, document) {
  const AMAZON_SCRIPT_ID = "amzn-pixel";
  const AMAZON_SCRIPT_SRC = "https://c.amazon-adsystem.com/aat/amzn.js";
  const AMAZON_REGION = "NA";
  const AMAZON_TAG = "dabd0c20-a0e4-4110-ad83-a0098ed3b1e4";
  const PENDING_NEWSLETTER_EMAIL_KEY = "rr_amazon_ads_pending_newsletter_email";

  function initAmazonAds() {
    if (!window.amzn) {
      window.amzn = function () {
        window.amzn.q.push([arguments, new Date().getTime()]);
      };
      window.amzn.q = [];
      window.amzn.version = "0.0";
    }

    if (!document.getElementById(AMAZON_SCRIPT_ID)) {
      var script = document.createElement("script");
      var firstScript = document.getElementsByTagName("script")[0];
      script.src = AMAZON_SCRIPT_SRC;
      script.id = AMAZON_SCRIPT_ID;
      script.async = true;
      if (firstScript && firstScript.parentNode) {
        firstScript.parentNode.insertBefore(script, firstScript);
      } else {
        document.head.appendChild(script);
      }
    }

    if (!window.__rrAmazonAdsInitialized) {
      window.__rrAmazonAdsInitialized = true;
      window.amzn("setRegion", AMAZON_REGION);
      window.amzn("addTag", AMAZON_TAG);
    }
  }

  function normalizeEmail(email) {
    if (!email) return "";
    return String(email).trim().toLowerCase();
  }

  function readStoredHashEmail() {
    try {
      return localStorage.getItem("hashEmail") || "";
    } catch (error) {
      return "";
    }
  }

  function readStoredEmail() {
    try {
      return normalizeEmail(localStorage.getItem("userEmail") || "");
    } catch (error) {
      return "";
    }
  }

  function persistEmailContext(email, hashedEmail) {
    var normalizedEmail = normalizeEmail(email);
    if (!normalizedEmail || !hashedEmail) return;

    try {
      localStorage.setItem("userEmail", normalizedEmail);
      localStorage.setItem("hashEmail", hashedEmail);
    } catch (error) {
      return;
    }
  }

  async function getHashedEmail(email) {
    var normalizedEmail = normalizeEmail(email);
    if (!normalizedEmail) return readStoredHashEmail();

    var storedEmail = readStoredEmail();
    var storedHash = readStoredHashEmail();
    if (storedEmail === normalizedEmail && storedHash) {
      return storedHash;
    }

    if (!window.crypto || !window.crypto.subtle) return "";

    var data = new TextEncoder().encode(normalizedEmail);
    var hashBuffer = await window.crypto.subtle.digest("SHA-256", data);
    var hashArray = Array.from(new Uint8Array(hashBuffer));
    var hashedEmail = hashArray
      .map(function (item) {
        return item.toString(16).padStart(2, "0");
      })
      .join("");

    persistEmailContext(normalizedEmail, hashedEmail);
    return hashedEmail;
  }

  function setPendingNewsletterEmail(email) {
    var normalizedEmail = normalizeEmail(email);
    if (!normalizedEmail) return;

    try {
      localStorage.setItem(PENDING_NEWSLETTER_EMAIL_KEY, normalizedEmail);
    } catch (error) {
      return;
    }
  }

  function getPendingNewsletterEmail() {
    try {
      return normalizeEmail(localStorage.getItem(PENDING_NEWSLETTER_EMAIL_KEY) || "");
    } catch (error) {
      return "";
    }
  }

  function clearPendingNewsletterEmail() {
    try {
      localStorage.removeItem(PENDING_NEWSLETTER_EMAIL_KEY);
    } catch (error) {
      return;
    }
  }

  function parseDiscountPercent(value) {
    var match = String(value || "").match(/(\d+(?:\.\d+)?)\s*%/);
    return match ? match[1] : "";
  }

  async function resolveHashedEmail(email, hashedEmail) {
    if (hashedEmail) return String(hashedEmail).trim();
    return getHashedEmail(email || readStoredEmail());
  }

  function sanitizePayload(payload) {
    var nextPayload = {};
    Object.keys(payload || {}).forEach(function (key) {
      var value = payload[key];
      if (value === undefined || value === null || value === "") return;
      nextPayload[key] = value;
    });
    return nextPayload;
  }

  function trackEvent(eventName, payload) {
    initAmazonAds();
    var nextPayload = sanitizePayload(payload);
    if (Object.keys(nextPayload).length) {
      window.amzn("trackEvent", eventName, nextPayload);
      return true;
    }
    window.amzn("trackEvent", eventName);
    return true;
  }

  async function trackNewsletterSubscribe(input) {
    var options = typeof input === "string" ? { email: input } : input || {};
    var hashedEmail = await resolveHashedEmail(options.email, options.hashedEmail);
    if (!hashedEmail) return false;

    clearPendingNewsletterEmail();
    return trackEvent("NewsletterSubscribe", {
      hashedEmail: hashedEmail,
    });
  }

  async function trackPendingNewsletterSubscribe(fallbackEmail) {
    var email = normalizeEmail(fallbackEmail) || getPendingNewsletterEmail() || readStoredEmail();
    var tracked = await trackNewsletterSubscribe({ email: email });
    if (tracked) {
      clearPendingNewsletterEmail();
    }
    return tracked;
  }

  async function trackSpecialAwards(input) {
    var options = input || {};
    var hashedEmail = await resolveHashedEmail(options.email, options.hashedEmail);
    if (!hashedEmail) return false;

    var discountPercent =
      options.discountPercent || parseDiscountPercent(options.discountTitle || "");

    return trackEvent("SpecialAwards", {
      hashedEmail: hashedEmail,
      discountCode: options.discountCode,
      discountPercent: discountPercent,
    });
  }

  window.RRAmazonAds = Object.assign({}, window.RRAmazonAds, {
    init: initAmazonAds,
    getHashedEmail: getHashedEmail,
    setPendingNewsletterEmail: setPendingNewsletterEmail,
    getPendingNewsletterEmail: getPendingNewsletterEmail,
    clearPendingNewsletterEmail: clearPendingNewsletterEmail,
    trackNewsletterSubscribe: trackNewsletterSubscribe,
    trackPendingNewsletterSubscribe: trackPendingNewsletterSubscribe,
    trackSpecialAwards: trackSpecialAwards,
    parseDiscountPercent: parseDiscountPercent,
  });

  initAmazonAds();
})(window, document);
